var StepperState;
(function (StepperState) {
    StepperState[StepperState["ACTIVE"] = 0] = "ACTIVE";
    StepperState[StepperState["DONE"] = 1] = "DONE";
    StepperState[StepperState["TODO"] = 2] = "TODO";
    StepperState[StepperState["ERROR"] = 3] = "ERROR";
})(StepperState || (StepperState = {}));
const State = {
    ACTIVE: StepperState.ACTIVE,
    DONE: StepperState.DONE,
    TODO: StepperState.TODO,
    ERROR: StepperState.ERROR,
};

export { StepperState, State as default };
